import React from 'react';
import { useSmallVideo } from '@/components/GridScenarioVideos';

// Dezentes Hintergrundvideo für die dunkle Hauptseite: Szene 1 (Mesh-Netz, Speicher laden und entladen).
// Dunkler Videohintergrund + mix-blend-mode: screen => verschmilzt mit dem dunklen Seitenhintergrund,
// nur die leuchtende Grafik bleibt sichtbar. Handy / Datensparmodus: kleine Datei.
// "Bewegung reduzieren" blendet das Video aus.
// Der Elternknoten braucht "relative isolate", damit das Video hinter dem Inhalt liegt.
export default function MeshBackgroundVideo({ opacity = 0.4 }) {
  const small = useSmallVideo();
  const src = small ? '/videos/grid-battery-small.mp4' : '/videos/grid-battery.mp4';
  return (
    <video
      key={src}
      src={src}
      className="fixed inset-0 -z-10 w-full h-full object-cover pointer-events-none motion-reduce:hidden"
      style={{ mixBlendMode: 'screen', opacity }}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
      tabIndex={-1}
      data-testid="mesh-background-video"
    />
  );
}
